import { render, staticRenderFns } from "./DetailOrderModal.vue?vue&type=template&id=52bc75e9&scoped=true"
import script from "./DetailOrderModal.vue?vue&type=script&lang=ts"
export * from "./DetailOrderModal.vue?vue&type=script&lang=ts"
import style0 from "./DetailOrderModal.vue?vue&type=style&index=0&id=52bc75e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc75e9",
  null
  
)

export default component.exports